var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getMusic)?_c('div',{staticClass:"hmt-audio"},[_c('button',{on:{"click":function($event){return _vm.togglePlay()}}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.isMuted ? 'volume-mute' : 'volume-up'}})],1),_c('audio',{ref:"audio",attrs:{"loop":"","autoplay":""}},[_c('source',{attrs:{"src":_vm.getMusic,"type":"audio/mpeg"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }